import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import LegalDocumentContent from './LegalDocumentContent';
import { getPrivacySections, getTermsSections } from './legalContent';

interface LegalDocumentLayoutProps {
  variant: 'terms' | 'privacy';
}

const LegalDocumentLayout: React.FC<LegalDocumentLayoutProps> = ({ variant }) => {
  const bg = useColorModeValue('gray.50', 'gray.900');
  const cardBg = useColorModeValue('white', 'gray.800');

  const title = variant === 'terms' ? 'Terms of Service' : 'Privacy Policy';
  const sections = variant === 'terms' ? getTermsSections() : getPrivacySections();

  return (
    <Box minH="100vh" bg={bg} py={12}>
      <Container maxW="3xl">
        <VStack align="stretch" spacing={6}>
          <Button as={RouterLink} to="/" variant="link" colorScheme="blue" alignSelf="start">
            Back to home
          </Button>

          <Box bg={cardBg} borderRadius="xl" p={{ base: 6, md: 8 }} boxShadow="sm">
            <LegalDocumentContent title={title} sections={sections} />
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};

export default LegalDocumentLayout;
